/**
 * 泳池培训侧栏结构（仅作面包屑/标题解析辅助）。
 * 正式菜单与授权以库表 t2_swim_permission_item（training:*）为准。
 */
export interface PoolTrainingMenuLeaf {
  path: string;
  name: string;
  icon?: string;
}

export interface PoolTrainingMenuGroup {
  path: string;
  name: string;
  icon?: string;
  children: PoolTrainingMenuLeaf[];
}

export const POOL_TRAINING_MENU_GROUPS: PoolTrainingMenuGroup[] = [
  {
    path: '/training/coach',
    name: '教练管理',
    icon: 'TeamOutlined',
    children: [
      {
        path: '/training/coach/styleProfile',
        name: '教练风采',
        icon: 'IdcardOutlined',
      },
      {
        path: '/training/coach/feeRate',
        name: '教练费率',
        icon: 'PercentageOutlined',
      },
      {
        path: '/training/coach/schedule',
        name: '教练课表',
        icon: 'CalendarOutlined',
      },
      {
        path: '/training/coach/settlement',
        name: '教练对账',
        icon: 'AccountBookOutlined',
      },
      {
        path: '/training/coach/feeSettlement',
        name: '教练结算',
        icon: 'MoneyCollectOutlined',
      },
    ],
  },
  {
    path: '/training/course',
    name: '课程管理',
    icon: 'ReadOutlined',
    children: [
      {
        path: '/training/course/productDefinition',
        name: '课程定义',
        icon: 'FormOutlined',
      },
    ],
  },
  {
    path: '/training/order',
    name: '订单与支付',
    icon: 'PayCircleOutlined',
    children: [
      {
        path: '/training/order/list',
        name: '常规订单',
        icon: 'UnorderedListOutlined',
      },
      {
        path: '/training/order/payOrderList',
        name: '支付单',
        icon: 'TransactionOutlined',
      },
      {
        path: '/training/order/deductionVoucher',
        name: '抵扣单',
        icon: 'GiftOutlined',
      },
    ],
  },
  {
    path: '/training/scheduling',
    name: '排班管理',
    icon: 'ClusterOutlined',
    children: [
      {
        path: '/training/scheduling/execution',
        name: '排班执行',
        icon: 'DeploymentUnitOutlined',
      },
      {
        path: '/training/scheduling/paidStudentList',
        name: '班级列表',
        icon: 'TeamOutlined',
      },
      {
        path: '/training/scheduling/courseList',
        name: '课程列表',
        icon: 'ReadOutlined',
      },
    ],
  },
  {
    path: '/training/academic',
    name: '教务运营',
    icon: 'SolutionOutlined',
    children: [
      {
        path: '/training/academic/courseList',
        name: '课程列表',
        icon: 'UnorderedListOutlined',
      },
      {
        path: '/training/academic/studentList',
        name: '学员列表',
        icon: 'ContactsOutlined',
      },
      {
        path: '/training/academic/leaveList',
        name: '请假列表',
        icon: 'CalendarOutlined',
      },
      {
        path: '/training/academic/classTransfer',
        name: '调班列表',
        icon: 'SwapOutlined',
      },
      {
        path: '/training/academic/classTransferReview',
        name: '调班审核',
        icon: 'AuditOutlined',
      },
      {
        path: '/training/academic/commentModeration',
        name: '评论治理',
        icon: 'CommentOutlined',
      },
    ],
  },
  {
    path: '/training/statistics',
    name: '统计分析',
    icon: 'BarChartOutlined',
    children: [
      {
        path: '/training/statistics/courseTheme',
        name: '课程统计',
        icon: 'BookOutlined',
      },
      {
        path: '/training/statistics/orderPayment',
        name: '订单统计',
        icon: 'FundOutlined',
      },
      {
        path: '/training/statistics/studentTheme',
        name: '学员统计',
        icon: 'UserOutlined',
      },
      {
        path: '/training/statistics/courseCoach',
        name: '分班排课',
        icon: 'LineChartOutlined',
      },
      {
        path: '/training/statistics/courseExecution',
        name: '执行销课',
        icon: 'AuditOutlined',
      },
    ],
  },
];

export const POOL_TRAINING_MENU_ITEMS: PoolTrainingMenuLeaf[] =
  POOL_TRAINING_MENU_GROUPS.flatMap((g) => g.children);

/** 已并入调班列表，侧栏不再单独展示 */
export const RETIRED_TRAINING_MENU_PATHS = [
  '/training/academic/transferCredit',
];
export const RETIRED_TRAINING_MENU_CODES = ['training:academic:transferCredit'];
